<div class="ui-fluid ui-g-12 card">
  <!-- Report User, Roles -->
<div class="ui-g-12">

  <div class="description ui-g-12">
    {{ 'report.userRolesReport' | translate }}
    <hr>
  </div>

  <div class="ui-g-12">
      <i class="fa fa-info-circle icon" style="float: right;" pTooltip="{{ 'report.info' | translate }}" tooltipPosition="left" (click)="openDialog('reportUserRoles')"></i>
  </div>

  <!-- Filtri Report -->
  <div class="padd ui-g-12">

     <!-- Company -->
     <div class="ui-g-6 padd-top">
      <label>{{ 'common.company' | translate }}</label>
      <br><br>
      <p-dropdown [style]="{'width':'60%'}" [options]="companies" [(ngModel)]="companySelectedUserRoles"></p-dropdown>
    </div>

    <!-- Utente -->
    <div class="ui-g-6">
      <label>{{ 'common.username' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showUserUserRoles"></p-inputSwitch>
      <br><br>
      <p-dropdown [style]="{'width':'60%'}" [disabled]="!showUserUserRoles" [options]="users" [(ngModel)]="userSelectedUserRoles" [filter]="true"></p-dropdown>
    </div>

    <!-- Login -->
    <div class="ui-g-6 padd-top">
      <label>{{ 'userForm.login' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showLogin"></p-inputSwitch>
      <br><br>
      <input [disabled]="!showLogin" [(ngModel)]="login" pInputText />
    </div>

    <!-- Email -->
    <div class="ui-g-6 padd-top">
      <label>{{ 'userForm.email' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showEmail"></p-inputSwitch>
      <br><br>
      <input [disabled]="!showEmail" [(ngModel)]="email" pInputText />
    </div>

  </div>

  <div class="ui-g-12 text-center padd-top">
    <p-button
        styleClass="ui-button-info"
        label="{{ 'report.viewReport' | translate }}"
        (onClick)="reportUserRoles()"
        >
      </p-button>
  </div>
</div>
</div>

<!-- Report -->
<div  *ngIf="showReport" class="ui-g-12">
  <app-view-report
  [showUserRoles]="showReportUserRoles"
  [data]="report">
  </app-view-report>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-user-roles/report-user-roles.component.html